import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin';
import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html';
import { $getRoot, $insertNodes } from 'lexical';

const InitialHtmlLoader = ({ initialText }) => {
  const [editor] = useLexicalComposerContext();
  const loadedText = useRef(null);

  useEffect(() => {
    if (loadedText.current === initialText) return;
    loadedText.current = initialText;

    editor.update(() => {
      const root = $getRoot();
      root.clear();

      const parser = new DOMParser();
      const dom = parser.parseFromString(typeof initialText === 'string' ? initialText : '', 'text/html');
      const nodes = $generateNodesFromDOM(editor, dom);
      root.select();
      $insertNodes(nodes);
    });
  }, [editor, initialText]);

  return null;
};

InitialHtmlLoader.propTypes = {
  initialText: PropTypes.string
};

const HtmlSyncPlugin = ({ initialText, onHtmlChange }) => {
  const [editor] = useLexicalComposerContext();

  return (
    <>
      <InitialHtmlLoader initialText={initialText} />
      <OnChangePlugin
        onChange={editorState => {
          editorState.read(
            () => {
              onHtmlChange($generateHtmlFromNodes(editor, null));
            },
            { editor }
          );
        }}
      />
    </>
  );
};

HtmlSyncPlugin.propTypes = {
  initialText: PropTypes.string,
  onHtmlChange: PropTypes.func.isRequired
};

export default HtmlSyncPlugin;
